import { render, staticRenderFns } from "./ShopClose.vue?vue&type=template&id=b30b6230&"
import script from "./ShopClose.vue?vue&type=script&lang=js&"
export * from "./ShopClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports